import { render, staticRenderFns } from "./CongrModal.vue?vue&type=template&id=047b043a"
import script from "./CongrModal.vue?vue&type=script&lang=js"
export * from "./CongrModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports